import { useCallback } from 'react';

export const useNumberKeySelectorCallback = (minValue, maxValue, callback) => {
  return useCallback(
    (event) => {
      const { key } = event;
      if (key >= minValue && key <= maxValue && document.activeElement.id !== 'outlined-multiline-comments') {
        event.preventDefault();
        callback(parseInt(key, 10));
      }
    },
    [minValue, maxValue, callback],
  );
};
